import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { Http } from "@status/codes";
import Snackbar from "../../../../shared/components/Snackbar/Snackbar";
import { DependenciesService } from "../../../Dependencies/services/DependenciesService";
import { CampusService } from "../../../Campus/services/CampusService";
import { SpaceService } from "../../../Space/services/SpaceService";
import {
  AVAILABILITY_CONSTANTS,
  AVAILIABILITY_ACCESS,
  DEFAULT_TIME,
  MINUS_FIVE_HOURS,
  UPDATING_TITLE
} from "../../constants/AvailabilityConstants";
import {
  USER_ACCESS,
  USER_CONSTANTS
} from "../../../User/constants/UserConstants";
import { CampusModel } from "../../../Campus/models/CampusModel";
import { Dependency } from "../../../Dependencies/models/Dependency";
import { UserQuery } from "../../../User/models/UserQuery";
import { UserService } from "../../../User/services/UserService";
import { UserStatus } from "../../../User/models/UserStatus";
import { SpaceHeader } from "../../../Space/models/SpaceHeader";
import { AvailabilityModel } from "../../models/AvailabilityModel";
import { ServiceTemplateService } from "../../../ServiceTemplate/services/ServiceTemplateService";
import { ServiceTemplateHeader } from "../../../ServiceTemplate/models/ServiceTemplateHeader";
import {
  GENERAL_CONSTANTS,
  STATE
} from "../../../../shared/constants/GeneralConstants";
import { AvailabilityService } from "../../services/AvailabilityService";
import { AvailabilityOnCreateModel } from "../../models/AvailabilityOnCreateModel";
import { DependencyAllData } from "@/modules/Dependencies/models/DependencyAllData";
import { PreventKey } from "@/shared/mixins/mixins";
import { AxiosError } from "axios";
import { CAMPUS_ACCESS } from "@/modules/Campus/constants/CampusConstants";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { SPACES_ACCESS } from "@/modules/Space/constants/SpaceConstants";
import { DEPENDENCIES_ACCESS } from "@/modules/Dependencies/constants/DependenciesConstants";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ServiceTemplateByAvailability } from "@/modules/ServiceTemplate/models/ServiceTemplateByAvailability.model";
import { AvailabilityTemplate } from "@/modules/AvailabilityTemplate/models/AvailabilityTemplateModel";

Vue.use(Vuetify);
@Component({
  name: "SaveAvailability",
  components: {
    DynamicSelect
  }
})
export default class SaveAvailability extends PreventKey {
  @Inject() dependenciesService!: DependenciesService;
  @Inject() campusService!: CampusService;
  @Inject() spaceService!: SpaceService;
  @Inject() userService!: UserService;
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() availabilityService!: AvailabilityService;

  @Prop() private dialogObservationProp?: boolean;
  @Prop() private availabilityDateProp!: string;
  @Prop() private startTimeProp!: string;
  @Prop() private endTimeProp!: string;
  @Prop() private availabilityIdProp!: string;
  @Prop() private isExtendEvent!: boolean;
  @Prop() private changeResponsables!: boolean;
  @Prop() private responsablesToChange!: string[];
  @Prop() private availabilityDefaultData!: AvailabilityOnCreateModel;
  @Prop() private loadingData!: boolean;

  TITLE = "";
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;
  WEEK_DAYS = AVAILABILITY_CONSTANTS.WEEK_DAYS;
  STATES = AVAILABILITY_CONSTANTS.STATES;
  LABELS = AVAILABILITY_CONSTANTS.LABEL;
  LOCALE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.LOCALE;
  ALLOWED_MINUTES = AVAILABILITY_CONSTANTS.CONFIGURATIONS.ALLOWED_MINUTES;
  SHOULD_CHOOSE = AVAILABILITY_CONSTANTS.TEXTS.SHOULD_CHOSE_SERVICE_FIRST;
  LOAD_MORE_OPTIONS = GENERAL_CONSTANTS.TEXTS.LOAD_MORE_OPTIONS;
  SELECT_SERVICES = AVAILABILITY_CONSTANTS.TEXTS.SELECT_SERVICES;
  LIST_LOADING = AVAILABILITY_CONSTANTS.TEXTS.LIST_LOADING;

  requiredField = FORM_VALIDATORS.REQUIRED_FIELD;
  greaterZero = AVAILABILITY_CONSTANTS.VALIDATORS.GREATER_ZERO;
  numberField = FORM_VALIDATORS.NUMBER_FIELD;
  requiredLength = AVAILABILITY_CONSTANTS.VALIDATORS.REQUIRE_LENGTH;
  emptySpaceRules = AVAILABILITY_CONSTANTS.VALIDATORS.EMPTY_SPACE;
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  minTimeStartPicker = DEFAULT_TIME;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  vSelectSelectionClass =
    this.textFieldClass + " " + STYLE_CLASSES.V_SELECTIONS;
  cardClass = STYLE_CLASSES.CARD;
  switchClass = STYLE_CLASSES.SWITCH;
  accentColor = STYLE_CLASSES.CHIP_COLOR.ACCENT;

  campusList: CampusModel[] = [];
  serviceTemplateList: ServiceTemplateByAvailability[] = [];
  spaceList: SpaceHeader[] = [];
  dependencyList: Dependency[] = [];
  userList: UserStatus[] = [];
  durationList: number[] = [];

  availabilityForm = false;
  incomingAvailabilityName = false;
  availabilityName = "";
  menuAvailabilityDate = false;
  menuStartTime = false;
  menuEndTime = false;
  state = "";
  duration = 1;
  serviceTemplate: string[] | ServiceTemplateByAvailability[] = [];
  campus = "";
  space = "";
  capacity = 1;
  dependency: Dependency | string = "";
  availabilityTemplate: AvailabilityTemplate | string = "";
  managers: string[] | DynamicSelectData[] = [];
  recurrent = false;
  weekdays: number[] = [];
  untilDate = "";
  menuUntilDate = false;
  holidays = false;
  startTime = this.startTimeProp;
  endTime = this.endTimeProp;
  availabilityDate = this.availabilityDateProp;
  lastAvailability!: AvailabilityModel;
  fillWrongRequest = false;

  campusLastRef?: string = "";
  dependencyLastRef?: string = "";
  serviceTemplateLastRef?: string = "";
  spaceLastRef?: string = "";

  isEditing = false;
  availabilityEdit!: AvailabilityModel;
  recurrentDataCopy = false;
  refreshKey = 1;
  availabilityCopy?: AvailabilityModel;
  availabilityId = "";
  isReadOnly = true;
  isLoadingRequest = false;
  dependencyAuxList: DependencyAllData[] = [];
  lastDate = 0;
  lastRef = "";
  usersListConfigList: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    messageLabel: this.LABELS.MANAGER,
    hint: "",
    persistenthint: false,
    required: true,
    chips: true,
    loadingData: true,
    attach: true
  };

  minDateInDatePicker = () => {
    const dateNowInIsoFormat = new Date().getTime() - MINUS_FIVE_HOURS;
    return new Date(dateNowInIsoFormat).toISOString().split("T")[0];
  };
  keywordUsers = "";

  async getDependencyAndFilter() {
    this.dependencyList = [];
    await this.getAllDependencies();
    if (this.isEditing) {
      const currentDependencyKey = this.dependencyAuxList.filter(
        dependency => dependency.id === this.availabilityEdit.dependency
      );

      this.dependencyList = this.dependencyList.filter(
        dependency =>
          dependency.state === STATE.ACTIVE && dependency.external == false
      );

      const validation = this.dependencyList.find(
        dependency => dependency.id === currentDependencyKey[0].id
      );

      if (currentDependencyKey.length > 0 && !validation) {
        this.dependencyList.push(currentDependencyKey[0].data);
      }
    } else {
      this.dependencyList = this.dependencyList.filter(
        dependency =>
          dependency.state === STATE.ACTIVE && dependency.external == false
      );
    }
  }

  async getSpacesAndFilter() {
    this.spaceList = [];
    await this.getAllSpaces();
    if (this.isEditing) {
      const currentSpaceCampusKey = this.spaceList.filter(
        space => space._key === this.availabilityEdit.space
      );

      this.spaceList = this.spaceList.filter(
        space => space.state === STATE.ACTIVE
      );

      const validation = this.spaceList.find(a => {
        if (a._key === currentSpaceCampusKey[0]._key) return true;
      });

      if (currentSpaceCampusKey.length > 0 && !validation) {
        this.spaceList.push(currentSpaceCampusKey[0] as SpaceHeader);
      }
    } else {
      this.spaceList = this.spaceList.filter(
        space => space.state === STATE.ACTIVE
      );
    }
  }

  async getCampusAndFilter() {
    this.campusList = [];
    await this.getAllCampus();
    if (this.isEditing) {
      const currentCampusKey = this.campusList.filter(
        campus => campus._key === this.availabilityEdit.campus
      );

      this.campusList = this.campusList.filter(
        campus => campus.state === STATE.ACTIVE
      );

      const validation = this.campusList.find(
        a => a._key === currentCampusKey[0]._key
      );

      if (currentCampusKey.length > 0 && !validation) {
        this.campusList.push(currentCampusKey[0] as CampusModel);
      }
    } else {
      this.campusList = this.campusList.filter(
        campus => campus.state === STATE.ACTIVE
      );
    }
  }

  async getActiveServiceTemplatesAndFilter(key?: string) {
    if (key) {
      this.serviceTemplateList = [];
      await this.getAllActiveServicesTemplates(key);
    }
  }

  getMultiplesOfDuration(duration: number) {
    const multiplesArray = [];
    for (let j = 1; j <= duration; j++) {
      if (duration < 10) {
        multiplesArray.push(duration);
      }
      if (duration % j === 0 && j >= 10) {
        multiplesArray.push(j);
      }
    }
    this.durationList = multiplesArray.sort((a, b) => b - a);
  }

  @Watch("changeResponsables")
  async filledModalWithData() {
    this.availabilityEdit = { ...this.lastAvailability };
    this.fillWrongRequest = true;
    if (this.TITLE.includes(UPDATING_TITLE)) {
      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
    if (this.responsablesToChange.length > 0) {
      this.availabilityEdit.responsable = (this.availabilityEdit
        .responsable as string[])?.filter(
        a => !this.responsablesToChange.includes(a)
      );
    }
    await this.fillAvailability();
    if (this.availabilityEdit.until) {
      this.untilDate = this.getYearMonthDay(
        this.availabilityEdit.until as number
      );
    }
  }

  getYearMonthDay(date: number): string {
    const dateToGetDetails = new Date(date);
    const year = dateToGetDetails.getUTCFullYear();
    const month =
      dateToGetDetails.getUTCMonth() + 1 <
      AVAILABILITY_CONSTANTS.MONTHS_UNTIL_OCTOBER
        ? "0" + (dateToGetDetails.getUTCMonth() + 1)
        : dateToGetDetails.getUTCMonth() + 1;
    const day =
      dateToGetDetails.getUTCDate() + 1 <
      AVAILABILITY_CONSTANTS.MONTHS_UNTIL_OCTOBER
        ? "0" + dateToGetDetails.getUTCDate()
        : dateToGetDetails.getUTCDate();

    return year + "-" + month + "-" + day;
  }

  @Watch("dependency")
  async dataChanged(newDependency?: string, oldDependency?: string) {
    if (newDependency != oldDependency && newDependency && oldDependency) {
      this.usersListConfigList.listAll = [
        ...(this.managers as DynamicSelectData[])
      ];
      this.lastRef = "";
    }
    if (this.dependency) {
      try {
        const filterQuery: UserQuery = {
          dependency: [(this.dependency as Dependency).name]
        };
        const responseUsers = await this.userService.getUsersByFiltersArrayUsersCrud(
          filterQuery
        );

        if (responseUsers.code === Http.Found) {
          const usersMapped = responseUsers.data?.userArray.map(user => ({
            id: user.id,
            name: user.name
          })) as [{ id: string; name: string }];
          this.usersListConfigList.listAll = [
            ...this.usersListConfigList.listAll,
            ...usersMapped
          ];
          this.lastRef = responseUsers.data?.lastReference!;
          this.usersListConfigList.loadingData = false;
          return;
        }
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden) {
          Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET);
        } else {
          Snackbar.popError(
            (error as ReferenceError).message || FORM_MESSAGES.REQUEST_FAILED
          );
        }
      }
    }
  }

  @Watch("dialogObservationProp")
  async showModal(newValue?: boolean, oldValue?: boolean) {
    if (this.dialogObservationProp) {
      this.isLoadingRequest = true;
      this.isEditing = false;
      this.isReadOnly = true;
      this.availabilityId = this.availabilityIdProp;
      this.title();
      if (this.availabilityId) {
        this.isEditing = true;
        await this.getAvailability(this.availabilityId);
      } else {
        await this.getDependencyAndFilter();
        await this.getCampusAndFilter();
        await this.fillAvailabilityWithFilters(this.availabilityDefaultData);
        await this.getActiveServiceTemplatesAndFilter(
          this.availabilityDefaultData.name?.key
        );
      }
      if (!this.fillWrongRequest && this.isEditing) {
        this.refreshKey = 1 - this.refreshKey;
      }
      this.fillWrongRequest = false;
      this.isLoadingRequest = false;
    }
    if (newValue == false && oldValue == true) {
      this.resetFields();
    }
  }

  @Watch("serviceTemplate")
  enableAvailabilityName(newValue: string) {
    let serviceTmpAux = [...this.serviceTemplate];
    const serviceNames: string[] = [];

    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    serviceTmpAux = (serviceTmpAux as any[]).map(service => {
      if (typeof service === "string") {
        const serviceFromList = this.serviceTemplateList.find(
          item => item.id === (service as string)
        );
        return serviceFromList as ServiceTemplateHeader;
      }
      return service;
    });

    (serviceTmpAux as ServiceTemplateHeader[]).forEach(service => {
      const serviceName = this.serviceTemplateList.find(
        serviceItem => serviceItem.id === service.id
      )?.internalName as string;
      serviceNames.push(serviceName);
    });

    if (!this.isEditing) {
      if (newValue.length > 0) {
        this.isReadOnly = false;
      } else {
        this.isReadOnly = true;
        this.availabilityForm = false;
      }
    }
  }

  stringDates(dateToConvert: string): string {
    const splitDateString: string[] = new Date(
      new Date(dateToConvert).getTime() + (86400000 + 18000000)
    )
      .toISOString()
      .split("T");
    return splitDateString[0];
  }

  @Watch("dialogObservationProp")
  @Watch("recurrent")
  changeUntilDefaultValue() {
    if (this.dialogObservationProp) {
      if (
        this.availabilityDate &&
        this.recurrent &&
        this.availabilityId === ""
      ) {
        this.untilDate = this.stringDates(this.availabilityDate);
      } else if (
        this.availabilityDate &&
        this.recurrent &&
        this.availabilityId !== "" &&
        !this.availabilityEdit.recurrent &&
        !this.availabilityEdit.until
      ) {
        this.untilDate = this.untilDate = this.stringDates(
          this.availabilityDate
        );
      } else if (!this.recurrent) {
        this.untilDate = "";
        this.weekdays = [];
        this.holidays = false;
      }
    }
  }

  isTheSameDay() {
    const todayRefDate = new Date();
    todayRefDate.setHours(0, 0, 0, 0);
    const calendarRefDate = this.transformToDates(
      this.availabilityDate as string
    );
    calendarRefDate.setHours(0, 0, 0, 0);

    if (todayRefDate.getDate() === calendarRefDate.getDate()) {
      return true;
    }

    return false;
  }

  isADifferentDayChange(lastDay: number) {
    const calendarRefDate = this.transformToDates(
      this.availabilityDate as string
    );

    calendarRefDate.setHours(0, 0, 0, 0);

    if (lastDay !== 0 && lastDay !== calendarRefDate.getDate()) {
      return true;
    }

    return false;
  }

  @Watch("availabilityDate")
  @Watch("startTime")
  @Watch("endTime")
  checkStartimeByDateChosen() {
    const now = new Date();
    if (this.availabilityDate && !this.isEditing) {
      const calendarRefDate = this.transformToDates(
        this.availabilityDate as string
      );
      calendarRefDate.setHours(0, 0, 0, 0);
      if (this.startTime) {
        let eventBaseStartTime = this.transformToDates(
          this.availabilityDate as string
        );
        eventBaseStartTime = this.includeDateTime(
          eventBaseStartTime,
          this.startTime as string
        );
        if (
          this.transformToDates(
            this.availabilityDate as string
          ).toDateString() === now.toDateString()
        ) {
          if (
            eventBaseStartTime &&
            this.isTheSameDay() &&
            this.isADifferentDayChange(this.lastDate)
          ) {
            this.startTime = "";
          }
        }
      }
      if (this.endTime) {
        let eventBaseEndTime = this.transformToDates(
          this.availabilityDate as string
        );
        eventBaseEndTime = this.includeDateTime(
          eventBaseEndTime,
          this.endTime as string
        );
        if (
          this.transformToDates(
            this.availabilityDate as string
          ).toDateString() === now.toDateString()
        ) {
          if (
            eventBaseEndTime &&
            this.isTheSameDay() &&
            this.isADifferentDayChange(this.lastDate)
          ) {
            this.endTime = "";
          }
        }
      }
      if (
        this.transformToDates(
          this.availabilityDate as string
        ).toDateString() === now.toDateString()
      ) {
        if (now.getMinutes() > 0) {
          let min = 0;
          const nowStartReference = new Date();
          if (now.getMinutes() % 5 === 0) {
            min = now.getMinutes();
          } else {
            min = now.getMinutes() + 5 - (now.getMinutes() % 5);
          }
          nowStartReference.setMinutes(min, 0);

          const startTimeToPick = nowStartReference
            .toLocaleTimeString()
            .split(":");
          this.minTimeStartPicker = `${startTimeToPick[0]}:${startTimeToPick[1]}`;
        } else if (now.getMinutes() === 0) {
          const nowEndReference = new Date();
          nowEndReference.setMinutes(0, 0);

          const endTimeToPick = nowEndReference.toLocaleTimeString().split(":");
          this.minTimeStartPicker = `${endTimeToPick[0]}:${endTimeToPick[1]}`;
        }
      } else {
        this.minTimeStartPicker = DEFAULT_TIME;
      }
      this.lastDate = calendarRefDate.getDate();
    } else {
      this.minTimeStartPicker = DEFAULT_TIME;
    }
  }

  includeDateTime(dateTime: Date, stringTime: string): Date {
    const splitTime = stringTime.split(":");
    const hour = Number.parseInt(splitTime[0]);
    const minute = Number.parseInt(splitTime[1]);
    dateTime.setHours(hour, minute, 0);
    return dateTime;
  }

  accept() {
    let isValid = true;
    if (this.managers.length === 0) {
      Snackbar.popWarning(
        AVAILABILITY_CONSTANTS.TEXTS.MUST_BE_SELECTED_MANAGER
      );
      isValid = false;
    }
    if (isValid && this.isInvalidDate(this.availabilityDate)) {
      Snackbar.popWarning(AVAILABILITY_CONSTANTS.TEXTS.INVALID_DATE);
      isValid = false;
    }
    if (
      !this.isEditing &&
      isValid &&
      this.isInvalidUntilDate(this.untilDate, this.availabilityDate)
    ) {
      Snackbar.popWarning(AVAILABILITY_CONSTANTS.TEXTS.INVALID_UNTIL_DATE);
      isValid = false;
    }
    if (isValid && this.hasInvalidTimes(this.startTime, this.endTime)) {
      Snackbar.popWarning(AVAILABILITY_CONSTANTS.TEXTS.INVALID_TIME);
      isValid = false;
    }
    if (
      !this.isEditing &&
      isValid &&
      !this.canDivideEvents(this.startTime, this.endTime, this.duration)
    ) {
      Snackbar.popWarning(AVAILABILITY_CONSTANTS.TEXTS.CANNOT_DIVIDE_EVENTS);
      isValid = false;
    }
    this.availabilityForm = false;
    const dateToChange = this.changerTimeZone(new Date(this.untilDate));
    let eventStart = this.transformToDates(this.availabilityDate as string);
    let eventEnd = this.transformToDates(this.availabilityDate as string);
    eventStart = this.includeDateTime(eventStart, this.startTime as string);
    eventEnd = this.includeDateTime(eventEnd, this.endTime as string);
    if (isValid) {
      const availabilityEvent: AvailabilityModel = {
        name: (this.availabilityTemplate as AvailabilityTemplate).name,
        availabilityTemplate: (this
          .availabilityTemplate as AvailabilityTemplate).id,
        start: eventStart.getTime(),
        end: eventEnd.getTime(),
        status: this.state,
        duration: this.duration,
        serviceTemplate: this.serviceTemplate as string[],
        campus: this.campus,
        space: this.space,
        capacity: this.capacity,
        dependency: (this.dependency as Dependency).id,
        responsable: (this.managers as DynamicSelectData[]).map(
          manager => manager.id
        ),
        recurrent: this.recurrent,
        until: dateToChange,
        holidays: this.holidays,
        weekdays: this.weekdays,
        timed: true
      };
      if (!this.isEditing) {
        this.lastAvailability = { ...availabilityEvent };
        this.$emit(
          AVAILABILITY_CONSTANTS.EVENTS.SAVE_MODAL_ACCEPT,
          { ...availabilityEvent },
          AVAILABILITY_CONSTANTS.EVENTS.CREATE_MODAL
        );
        this.isEditing = false;
      } else {
        const isEqual = this.compareAvailability(
          this.availabilityCopy as AvailabilityModel,
          availabilityEvent
        );

        if (isEqual && !this.isExtendEvent) {
          this.$emit("closeSaveAvailabilityModal");
        } else {
          this.$emit(
            AVAILABILITY_CONSTANTS.EVENTS.SAVE_MODAL_ACCEPT,
            availabilityEvent,
            AVAILABILITY_CONSTANTS.EVENTS.UPDATE_MODAL,
            (this.availabilityCopy as AvailabilityModel).recurrent
          );
        }
      }
    }
  }

  changerTimeZone(date: Date) {
    date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
    return date.getTime();
  }

  canDivideEvents(
    startTimeString: string,
    endTimeString: string,
    duration: number
  ) {
    const startTime = this.transformToDateTime(startTimeString);
    const endTime = this.transformToDateTime(endTimeString);
    const minutes = (endTime.valueOf() - startTime.valueOf()) / 60000;
    return minutes % duration == 0;
  }

  hasInvalidTimes(startTimeString: string, endTimeString: string) {
    const startTime = this.transformToDateTime(startTimeString);
    const endTime = this.transformToDateTime(endTimeString);
    return endTime.valueOf() <= startTime.valueOf();
  }

  transformToDateTime(stringTime: string): Date {
    const splitTime = stringTime.split(":");
    const hour = Number.parseInt(splitTime[0]);
    const minute = Number.parseInt(splitTime[1]);
    const dateTime = new Date();
    dateTime.setHours(hour, minute, 0);
    return dateTime;
  }

  isInvalidUntilDate(untilDateString: string, availabilityDateString: string) {
    const eventDate = this.transformToDates(availabilityDateString);
    const untilDate = this.transformToDates(untilDateString);
    return untilDate.valueOf() <= eventDate.valueOf();
  }

  isInvalidDate(availabilityDateString: string) {
    const eventDate = this.transformToDates(availabilityDateString);
    return eventDate.valueOf() < Date.now();
  }

  transformToDates(stringDate: string): Date {
    const splitDate = stringDate.split("-");
    const year = Number.parseInt(splitDate[0]);
    const month = Number.parseInt(splitDate[1]);
    const day = Number.parseInt(splitDate[2]);
    return new Date(year, month - 1, day, 23, 59, 59);
  }

  cancel() {
    this.fillWrongRequest = false;
    this.$emit(AVAILABILITY_CONSTANTS.EVENTS.SAVE_MODAL_CANCEL);
    this.resetFields();
  }

  resetFields() {
    if (!this.isEditing) {
      this.availabilityId = "";
    }
    this.availabilityForm = false;
    this.availabilityName = "";
    this.availabilityDate = this.availabilityDateProp;
    this.startTime = this.startTimeProp;
    this.endTime = this.endTimeProp;
    this.state = "";
    this.duration = 1;
    this.campus = "";
    this.space = "";
    this.capacity = 1;
    this.dependency = "";
    this.availabilityTemplate = "";
    this.managers = [];
    this.recurrent = false;
    this.weekdays = [];
    this.untilDate = "";
    this.holidays = false;
    this.recurrentDataCopy = false;
    this.isReadOnly = true;
  }

  async getAllCampus() {
    try {
      const response = await this.campusService.getAllCampusWithExtraInfo();
      if (response.code === Http.Found && response.data) {
        this.campusList = response.data;
      } else if (response.code === Http.NotFound) {
        Snackbar.popWarning(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CAMPUS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getAllActiveServicesTemplates(nameKey: string) {
    try {
      const response = await this.serviceTemplateService.getAllServiceTemplatesByAvailability(
        nameKey
      );

      if (response.code === Http.Ok && response.data) {
        this.serviceTemplateList = response.data;
        this.serviceTemplate = response.data;
      } else if (response.code === Http.NotFound) {
        Snackbar.popWarning(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  @Watch("campus")
  async getAllSpaces() {
    this.spaceList = [];
    try {
      const responseData = await this.spaceService.getAllSpacesWithFilters({
        campus: this.campus
      });

      if (responseData.code === Http.Found && responseData.data) {
        this.spaceList = responseData.data;
      } else if (responseData.code === Http.NotFound) {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + SPACES_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    if (!this.spaceList.map(x => x._key).includes(this.space)) {
      this.space = "";
    }
  }

  async getAllDependencies() {
    try {
      const responseData = await this.dependenciesService.findAll();

      if (responseData.code === Http.Found && responseData.data) {
        responseData.data = responseData.data.map(dependency => {
          return {
            id: dependency.id,
            data: {
              ...dependency.data,
              id: dependency.id
            }
          };
        });
        this.dependencyAuxList = responseData.data;
        this.dependencyList = responseData.data.map(
          a => (a.data as unknown) as Dependency
        );
      } else if (responseData.code === Http.NotFound) {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUsersById(usersArrayId: Array<string>) {
    const query: UserQuery = {
      usersId: usersArrayId
    };

    try {
      const responseData = await this.userService.getUsersByIdsArray(query);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        return responseData.data;
      } else {
        throw new ReferenceError(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_USERS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) throw error;
      throw Error(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  title() {
    if (this.availabilityId === "") {
      this.TITLE = AVAILABILITY_CONSTANTS.TEXTS.TITLE_SAVE;
    } else {
      this.TITLE = AVAILABILITY_CONSTANTS.TEXTS.TITLE_UPDATE;
    }
  }

  async getAvailability(id: string) {
    try {
      const response = await this.availabilityService.getAvailabilityDataEditById(
        id
      );
      if (response.code === Http.Found && response.data) {
        this.availabilityEdit = response.data;
        this.recurrentDataCopy = response.data.recurrent!;
        await this.getUsersTofillManagersArray(
          this.availabilityEdit.responsable as string[]
        );
        await this.getDependencyAndFilter();
        await this.getCampusAndFilter();
        await this.getSpacesAndFilter();

        await this.getActiveServiceTemplatesAndFilter(
          this.availabilityEdit.availabilityTemplate
        );
        this.incomingAvailabilityName = true;
        this.fillAvailability();
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async getUsersTofillManagersArray(managers: string[]) {
    this.usersListConfigList.listAll = (await this.getUsersById(managers)).map(
      user => ({
        id: user.id,
        name: user.name
      })
    ) as DynamicSelectData[];
  }

  async fillAvailability() {
    this.availabilityDate = this.getDates(
      new Date(this.availabilityEdit.start as number)
    );
    if (
      (!this.isExtendEvent && this.isEditing) ||
      (!this.isEditing && this.fillWrongRequest)
    ) {
      this.startTime = this.getHours(
        new Date(this.availabilityEdit.start as number)
      );
      this.endTime = this.getHours(
        new Date(this.availabilityEdit.end as number)
      );
    } else {
      this.startTime = this.startTimeProp;
      this.endTime = this.endTimeProp;
    }
    this.availabilityName = this.availabilityEdit.name as string;
    this.availabilityTemplate = {
      id: this.availabilityEdit.availabilityTemplate,
      name: this.availabilityName
    } as AvailabilityTemplate;
    this.duration = Number(this.availabilityEdit.duration);
    this.getMultiplesOfDuration(Number(this.availabilityEdit.duration));
    this.campus = this.availabilityEdit.campus as string;
    this.space = this.availabilityEdit.space as string;
    this.capacity = this.availabilityEdit.capacity as number;
    await this.getDependency(this.availabilityEdit.dependency as string);
    this.managers = this.usersListConfigList.listAll.filter(item => {
      return (this.availabilityEdit.responsable as string[])?.includes(
        item.id as string
      );
    });
    this.recurrent = this.availabilityEdit.recurrent as boolean;
    if (this.availabilityEdit.until) {
      this.untilDate = this.getDates(
        new Date(this.availabilityEdit.until as number)
      );
    }
    this.state = this.availabilityEdit.status;
    this.holidays = this.availabilityEdit.holidays as boolean;
    this.weekdays = this.availabilityEdit.weekdays as never[];

    const dateToChange = this.changerTimeZone(new Date(this.untilDate));
    let eventStart = this.transformToDates(this.availabilityDate as string);
    let eventEnd = this.transformToDates(this.availabilityDate as string);
    eventStart = this.includeDateTime(eventStart, this.startTime as string);
    eventEnd = this.includeDateTime(eventEnd, this.endTime as string);

    this.availabilityCopy = {
      name: this.availabilityName,
      start: eventStart.getTime(),
      end: eventEnd.getTime(),
      status: this.state,
      duration: this.duration,
      campus: this.campus,
      space: this.space,
      capacity: this.capacity,
      dependency: (this.dependency as Dependency).id,
      responsable: this.managers as DynamicSelectData[],
      recurrent: this.recurrent,
      until: dateToChange,
      holidays: this.holidays,
      weekdays: this.weekdays,
      timed: true
    };
  }

  async fillAvailabilityWithFilters(availability: AvailabilityOnCreateModel) {
    if (availability.service) {
      this.serviceTemplate = [availability.service.key as string];
    }

    if (this.startTimeProp) {
      this.startTime = this.startTimeProp;
      this.endTime = "";
    }

    if (this.availabilityDateProp) {
      this.availabilityDate = this.availabilityDateProp;
    }

    if (availability.name) {
      this.availabilityTemplate = {
        id: availability.name.key,
        name: availability.name.value as string
      };
      this.availabilityName = availability.name.value!;
      this.incomingAvailabilityName = true;
      this.isReadOnly = false;
    }

    if (availability.status) {
      this.state = availability.status.key;
    }

    if (availability.campus) {
      this.campus = availability.campus.key;
    }

    if (availability.space) {
      this.space = availability.space.key;
    }

    if (availability.dependency && availability.responsable) {
      await this.getDependency(availability.dependency.key);
      this.managers = [availability.responsable.key];
    }

    this.duration = 1;
    this.capacity = 1;
  }

  getHours(date: Date): string {
    const hour = date.getHours();
    const minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();

    return `${hour}:${minutes}`;
  }
  getDates(date: Date): string {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  async getDependency(id: string) {
    try {
      const resp = await this.dependenciesService.getDependency(id);

      if (resp.code === Http.Found && resp.data) {
        const dependency: Dependency = {
          id,
          name: resp.data.name,
          state: resp.data.state,
          users: resp.data.users,
          external: resp.data.external
        };
        this.dependency = dependency;
      } else {
        Snackbar.popInfo(resp.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  compareAvailability(
    availabilityCopy: AvailabilityModel,
    availabilitySend: AvailabilityModel
  ): boolean {
    const keys = Object.keys(availabilityCopy);
    let notEqual = 0;
    keys.forEach(key => {
      if (
        key !== AVAILABILITY_CONSTANTS.VALIDATE_KEYS.UNTIL &&
        key !== AVAILABILITY_CONSTANTS.VALIDATE_KEYS.WEEKDAYS &&
        key !== AVAILABILITY_CONSTANTS.VALIDATE_KEYS.RESPONSABLE &&
        key !== AVAILABILITY_CONSTANTS.VALIDATE_KEYS.SERVICES
      ) {
        if (
          availabilityCopy[key as keyof AvailabilityModel] !==
          availabilitySend[key as keyof AvailabilityModel]
        ) {
          notEqual++;
        }
      } else if (key === AVAILABILITY_CONSTANTS.VALIDATE_KEYS.SERVICES) {
        if (
          JSON.stringify(availabilityCopy[key as keyof AvailabilityModel]) !==
          JSON.stringify(availabilitySend[key as keyof AvailabilityModel])
        ) {
          notEqual++;
        }
      } else if (key === AVAILABILITY_CONSTANTS.VALIDATE_KEYS.UNTIL) {
        if (
          availabilityCopy[key as keyof AvailabilityModel] !==
          availabilitySend[key as keyof AvailabilityModel]
        ) {
          notEqual++;
        }
      } else if (key === AVAILABILITY_CONSTANTS.VALIDATE_KEYS.WEEKDAYS) {
        if (
          String(
            (availabilityCopy[
              key as keyof AvailabilityModel
            ] as string[]).sort()
          ) !=
          String(
            (availabilitySend[
              key as keyof AvailabilityModel
            ] as string[]).sort()
          )
        ) {
          notEqual++;
        }
      } else if (key === AVAILABILITY_CONSTANTS.VALIDATE_KEYS.RESPONSABLE) {
        if (
          String(
            (availabilityCopy[
              key as keyof AvailabilityModel
            ] as string[]).sort()
          ) !=
          String(
            (availabilitySend[
              key as keyof AvailabilityModel
            ] as string[]).sort()
          )
        ) {
          notEqual++;
        }
      }
    });
    if (notEqual > 0) {
      return false;
    } else {
      return true;
    }
  }

  async findUsers(name?: string) {
    try {
      const filterQuery: UserQuery = {
        dependency: [(this.dependency as Dependency).name],
        idReference: this.lastRef
      };
      if (this.keywordUsers !== name) {
        this.keywordUsers = name!;
        this.lastRef = "";
        delete filterQuery.idReference;
      }
      if (name) {
        filterQuery.notPaginate = true;
        filterQuery.name = [name];
      }
      const responseUsers = await this.userService.getUsersByFiltersArrayUsersCrud(
        filterQuery
      );

      if (responseUsers.code === Http.Found) {
        const users = responseUsers.data?.userArray.map(user => ({
          id: user.id,
          name: user.name
        })) as [{ id: string; name: string }];
        this.usersListConfigList.listAll = [
          ...this.usersListConfigList.listAll,
          ...users
        ];
        this.lastRef = responseUsers.data?.lastReference!;
        this.usersListConfigList.loadingData = false;
        return;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  viewService(serviceId: string) {
    localStorage.setItem(LOCAL_STORAGE.SERVICE_ID, serviceId);
    NavigationService.navigateTo(SystemView.SERVICES_TEMPLATE);
  }
}
